enum CategoryListEvents {
  CategoryItemClick = 'catalog_category_tap',
}

export default CategoryListEvents
